import React, { useCallback, useState } from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";

import Loading from "../../../../common/Loading";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";

import Button from "components/CustomButtons/Button";
import { Box } from "@material-ui/core";

const validationSchema = Yup.object().shape({
  count1099: Yup.number()
    .min(0, "Min value 0.")
    .required("Number of 1099s is required"),
  countw2: Yup.number()
    .min(0, "Min value 0.")
    .required("Number of W2s is required")
});

const W21099SummaryDialog = ({ open, data, onClose, onSave }) => {
  const handleSubmit = useCallback(
    values => {
      setDirty(true);
      onSave(values);
    },
    [onSave]
  );

  const [isDirty, setDirty] = useState(false);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Chapter Financial Information</DialogTitle>
      <DialogContent>
        <Grid container direction="column">
          <Box mb={3}>
            <Typography>
              <strong>W2 and 1099 Summary</strong>
            </Typography>
          </Box>
          <Box mb={2}>
            <Typography>
              Please fill in the total numbered issued of both types of document
            </Typography>
          </Box>
          <Formik
            initialValues={{
              count1099: data.count1099,
              countw2: data.countw2
            }}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            {({
              values,
              touched,
              errors,
              handleChange,
              handleBlur,
              isValid
            }) => (
              <Form autoComplete="off">
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  mb={2}
                >
                  <Typography>Number of 1099s issued:</Typography>
                  <TextField
                    error={Boolean(touched.count1099 && errors.count1099)}
                    helperText={
                      touched.count1099 &&
                      errors.count1099 &&
                      "Enter a valid number"
                    }
                    variant="outlined"
                    name="count1099"
                    value={values.count1099}
                    onChange={handleChange}
                  />
                </Box>
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  mb={2}
                >
                  <Typography>Number of W2s issued:</Typography>
                  <TextField
                    error={Boolean(touched.countw2 && errors.countw2)}
                    helperText={
                      touched.countw2 &&
                      errors.countw2 &&
                      "Enter a valid number"
                    }
                    variant="outlined"
                    name="countw2"
                    value={values.countw2}
                    onChange={handleChange}
                  />
                </Box>
                <Box display="flex" justifyContent="center" mt={2}>
                  {isDirty ? (
                    <Loading />
                  ) : (
                    <>
                      <Box mr={3}>
                        <Button
                          color="success"
                          variant="contained"
                          type="submit"
                        >
                          Submit
                        </Button>
                      </Box>
                      <Button
                        color="danger"
                        variant="contained"
                        onClick={onClose}
                      >
                        Cancel
                      </Button>
                    </>
                  )}
                </Box>
              </Form>
            )}
          </Formik>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default W21099SummaryDialog;
